if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.j=0;
      
      this.nextButton.addEventListener('click', ()=>{
        this.changeSlide('next')
      });
      this.prevButton.addEventListener('click', ()=>{
        this.changeSlide('prev')
      });
        let that=this;
       setTimeout(function(){
         that.auto(that.j);},3000);
         
    }
      auto(j){
          this.changeSlide("next");
        if(j< this.length-1){
          let that=this;
         setTimeout(function(){
           j++;
           that.auto(j);
           }
           , 3000);
       }
        else{
          let that=this;
          setTimeout(function(){
            that.index=0;
            j=0;
            that.auto(j);}
            , 3000);
        }
     }

    changeSlide(direction) {

      this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        this.index++;
      } else if ( direction == 'prev' ) {
        this.index--;
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled')
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled')
      }
      
      if(this.index > this.length-1){
        this.index=0;
        this.prevButton.classList.add('announcement-bar__content-nav--disabled')
      }
      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
                           

    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}